import React from "react";
import {
	Menu,
	MenuItem,
	Typography,
} from "@material-ui/core";
import {
	Close as CloseIcon,
	Replay as ReplayIcon,
} from "@material-ui/icons";
import api from "../../services/api";
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";

const TicketActionsMenu = ({ ticket, onUpdate, anchorEl, open, onClose }) => {
	const history = useHistory();

	if (!ticket) return null;

	const handleClose = () => {
		if (onClose) onClose();
	};

	const handleCloseTicket = async () => {
		handleClose();
		try {
			await api.put(`/tickets/${ticket.id}`, { status: "closed" });
			history.push("/atendimentos");
			if (onUpdate) onUpdate();
		} catch (err) { toastError(err); }
	};

	const handleReopenTicket = async () => {
		handleClose();
		try {
			await api.put(`/tickets/${ticket.id}`, { status: "open", userId: ticket.userId });
			history.push("/atendimentos");
			if (onUpdate) onUpdate();
		} catch (err) { toastError(err); }
	};

	return (
		<Menu
			anchorEl={anchorEl}
			open={Boolean(open)}
			onClose={handleClose}
			PaperProps={{ style: { minWidth: 180, borderRadius: 8 } }}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			disableScrollLock
		>
			{ticket.status !== "closed" && (
				<MenuItem onClick={handleCloseTicket} style={{ gap: 12, padding: "10px 16px" }}>
					<CloseIcon fontSize="small" style={{ color: "#ff9800" }} />
					<Typography style={{ fontSize: 14 }}>Fechar grupo</Typography>
				</MenuItem>
			)}

			{ticket.status === "closed" && (
				<MenuItem onClick={handleReopenTicket} style={{ gap: 12, padding: "10px 16px" }}>
					<ReplayIcon fontSize="small" style={{ color: "#00a884" }} />
					<Typography style={{ fontSize: 14 }}>Reabrir grupo</Typography>
				</MenuItem>
			)}
		</Menu>
	);
};

export default TicketActionsMenu;
